import React from 'react';
import { useTranslation } from 'react-i18next';
import { Wine, Coffee, Lock, ShoppingBag, User, Droplets } from 'lucide-react';
import { PageContainer } from '../../components/layout/PageContainer/PageContainer';
import { AmenityCard } from '../../components/features/AmenityCard/AmenityCard';
import { roomAmenities, heroImages } from '../../data/mockData';
import { useUIStore } from '../../stores/uiStore';

// Map icon names to Lucide components
const iconMap: Record<string, React.ReactNode> = {
  Wine: <Wine className="w-8 h-8" />,
  Coffee: <Coffee className="w-8 h-8" />,
  Lock: <Lock className="w-8 h-8" />,
  ShoppingBag: <ShoppingBag className="w-8 h-8" />,
  User: <User className="w-8 h-8" />,
  Droplets: <Droplets className="w-8 h-8" />,
};

export const RoomGuidePage: React.FC = () => {
  const { t } = useTranslation();
  const { openModal } = useUIStore();

  return (
    <PageContainer
      heroImage={heroImages.roomGuide}
      heroHeight="small"
      heroTitle={t('roomGuide.title')}
      heroSubtitle={t('roomGuide.subtitle')}
      overlayOpacity={0.45}
    >
      {/* Amenity Grid */}
      <div className="bg-white rounded-2xl p-6 shadow-[0_2px_8px_rgba(0,0,0,0.08)]">
        <h2 className="font-display text-2xl text-[#333333] mb-6">Room Amenities</h2>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {roomAmenities.map((amenity) => (
            <AmenityCard
              key={amenity.id}
              id={amenity.id}
              name={amenity.name}
              icon={iconMap[amenity.icon] || <Droplets className="w-8 h-8" />}
              onClick={() => openModal('amenity-detail', { name: amenity.name, description: amenity.description, icon: iconMap[amenity.icon] })}
            />
          ))}
        </div>
      </div>
    </PageContainer>
  );
};

export default RoomGuidePage;
